import { T } from "src/apps/components/i18n/Translation";
import { useState, useEffect } from "react";
import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";
import styled from "styled-components";
import { ResendTwoFactor } from "./ResendTwoFactor";
import { Button } from "src/apps/components/button/Button";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { BoldHeader1, Text } from "src/apps/components/typography/Texts";
import { useNavigate } from "react-router-dom";
import { useAuth } from "src/apps/hooks/useAuth";
import { useSendTwoFactor } from "src/apps/hooks/useSendTwoFactor";
import { FadeInAnimation } from "src/apps/components/fadeIn/FadeInAnimation";
import { FormContainer } from "./FormContainer";
import { useTheme } from "src/apps/providers/ThemeStore";
import { LoginTypes } from "../../../../contexts/auth/application/AuthController";
import { useGetUserLink } from "src/apps/hooks/useGetUserLink";

const GO_BACK_DELAY_MS = 30 * 1000;

const DOCUMENTATION_AREA_LOGIN_OTP_TITLE = "documentation_area.login.otp.title";
const DOCUMENTATION_AREA_LOGIN_OTP_GOBACK_BUTTON_TEXT =
  "documentation_area.login.otp.goback_button_text";
const DOCUMENTATION_AREA_LOGIN_MAGIC_LINK_SUBTITLE = "documentation_area.login.magic_link.subtitle";

export const MagicLinkParkingContainer = () => {
  const { userLink } = useGetUserLink();
  const navigate = useNavigate();
  const { mutate: resendTwoFactor } = useSendTwoFactor();
  const { t } = useTranslations();
  const { loginEmail } = useAuth();
  const { blackColor } = useTheme();
  const [showGoBack, setShowGoBack] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowGoBack(true), GO_BACK_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const goBack = () => {
    navigate(-1);
  };

  const onResendMagicLinkClick = () => {
    resendTwoFactor(loginEmail);
  };

  return (
    <FadeInAnimation duration={0.7}>
      <FormContainer>
        <Icon size={ICON_SIZES.s30} path={ICON_PATHS.SHIELD_CHECK} color={blackColor} />
        <BoldHeader1>
          <T k={DOCUMENTATION_AREA_LOGIN_OTP_TITLE} />
        </BoldHeader1>
        <Text>
          <T
            k={DOCUMENTATION_AREA_LOGIN_MAGIC_LINK_SUBTITLE}
            params={{ emailAddress: loginEmail }}
          />
        </Text>
        <ResendTwoFactor
          resendTwoFactor={onResendMagicLinkClick}
          loginType={LoginTypes.EMAIL_LINK}
        />
        <ButtonsContainer>
          {showGoBack && !userLink ? (
            <Button
              onClick={goBack}
              variant="ghost"
              text={t(DOCUMENTATION_AREA_LOGIN_OTP_GOBACK_BUTTON_TEXT)}
            />
          ) : null}
        </ButtonsContainer>
      </FormContainer>
    </FadeInAnimation>
  );
};

const ButtonsContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;

  flex-direction: column;
  gap: 8px;
`;
